import { Component, OnInit } from '@angular/core';
import { AiservicesService } from '../services/aiservices.service';
@Component({
  selector: 'app-transformeranalytics',
  templateUrl: './transformeranalytics.component.html',
  styleUrls: ['./transformeranalytics.component.scss']
})
export class TransformeranalyticsComponent implements OnInit {
  messages: any = [];

  constructor(private aiServices:AiservicesService) { }

  ngOnInit() {
    this.getOilData();
  }
getOilData(){
  this.aiServices.getMaxOilTime({"deviceid":"D001L22"}).subscribe((response: any) => {
    console.log("data",response);
    const temperatures = response.result.map(entry => entry.Oil_Temperature);
    let load = response.result.map(entry => entry.loadPercentage);
    let oilLevel = response.result.map(entry => entry.Oil_Level);
    let windingTemp = response.result.map(entry => entry.Winding_Temperature);
    let AmbientTemp = response.result.map(entry => entry.Ambient_Temperature);
    let dates = response.result.map(entry => entry.datetime);
   // const allKeys = response.analysisData.flatMap(item => item.keys);
    console.log("anasysyis",response.analysisData);
    this.messages = response.message;
    console.log("]]]]]]]]]]]]]]]]",this.messages)
    let opacityArray = [];
    var options = {
      series: [
        {
          name: "Oil Temp",
          data: temperatures,
          color: '#FF4560',
          opacity: 1 // Highlighted
        },
        {
          name: "Load (%)",
          data: load,
          color: '#00E396',
          opacity: 0.2 // Dimmed
        },
        {
          name: "Oil Level",
          data: oilLevel,
          color: '#008FFB',
          opacity: 0.2 // Dimmed
        },
        {
          name: "Winding Temp",
          data: windingTemp,
          color: '#FFB74D',
          opacity: 0.2 // Dimmed
        },
        {
          name: "Ambient Temp",
          data: AmbientTemp,
          color: '#9C27B0',
          opacity: 0.2 // Dimmed
        }
      ],
      chart: {
        type: 'line',
        stacked: false,
        height: "100%",
        zoom: {
          type: 'x',
          enabled: true,
          autoScaleYaxis: true
        },
        toolbar: {
          show: true
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth',
        width: 2,
        colors: ['#FF4560', '#00E396', '#008FFB', '#FFB74D', '#9C27B0'], // Set colors for each series
        opacity: [1, 0.2, 0.2, 0.2, 0.5] // Set opacity for each series
      },
      fill: {
        opacity: [1, 0.2, 0.2, 0.2, 1] // Set fill opacity for each series
      },
      title: {
        text: 'Max Oil Temperature Compared with Other Parameters',
        align: 'left',
        style: {
          fontSize: '16px',
          fontWeight: 'bold',
          color: '#263238'
        }
      },
      grid: {
        borderColor: '#e0e0e0',
        row: {
          colors: ['#f3f3f3', '#ffffff'],
          opacity: 0.5
        },
      },
      xaxis: {
        categories: dates,
        tickAmount: 5,
        tickPlacement: 'between',
        labels: {
          rotate: 0,
          style: {
            colors: '#6c757d',
            fontSize: '12px'
          }
        },
        title: {
          text: 'Date',
          style: {
            color: '#6c757d',
            fontSize: '14px'
          }
        }
      },
      yaxis: [
        {
          title: {
            text: 'Temperature (°C)',
            style: {
              color: '#FF4560',
              fontSize: '14px'
            }
          },
          labels: {
            style: {
              colors: '#FF4560'
            }
          }
        }
      ],
      tooltip: {
        shared: true,
        intersect: false,
        y: {
          formatter: function (value) {
            return value.toFixed(2);
          }
        }
      },
      legend: {
        position: 'top',
        horizontalAlign: 'right',
        offsetY: 0
      }
    };
    
    var chart = new ApexCharts(document.querySelector("#chart"), options);
    chart.render();
    



  });
}
}
